import { useContext, useEffect, useRef, useState } from 'react';
import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { Alert, Button, Col, Dropdown, Form, Input, Modal, Popconfirm, Row, Select, Space, Spin, Switch, Tooltip } from 'antd';
import BranchStoreMenuWarehouseEdit from '../menu/BranchStoreMenuWarehouseEdit';
import Synchronize from './Synchronize';
// import WarehouseToMenu from '../menu/WarehouseToMenu';
import BranchStoreMenuWarehouseSpec from '../menu/BranchStoreMenuWarehouseSpec';
import CopyMenuWarehouse from './CopyMenuWarehouse';
import MenuWarehouseIngredient from '../ingredient/MenuWarehouseIngredient';
import MenuIcon from './MenuIcon';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
// import BranchStoreList from '../../generalComponents/BranchStoreList';
import getList from '../../universal/getList';
// import fetchApi from '../../../utils/api/fetchApi';
// import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

//组件 BranchStoreMenuWarehouse 
export default function BranchStoreMenuWarehouse(props: any) {

    const ref = useRef<any>(undefined);
    const [form] = Form.useForm();
    const [batchOperationForm] = Form.useForm();
    const notificationApi = useNotificationInstance();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    //是否搜索规格
    const [isSearchSpec, setIsSearchSpec] = useState<any>();

    //门店扩展信息
    const [branchStoreConfiguration, setBranchStoreConfiguration] = useState<any>();

    //同步窗口
    const [synchronizeVisible, setSynchronizeVisible] = useState(false);

    //同步数据
    const [synchronizeData, setSynchronizeData] = useState<any>();

    //不打印窗口
    const [noPrintOrderVisible, setNoPrintOrderVisible] = useState(false);

    //同步数据
    // const [noPrintOrderData, setNoPrintOrderData] = useState<any>();

    //图标窗口
    const [menuIconVisible, setMenuIconVisible] = useState(false);

    //图标数据
    const [menuIconData, setMenuIconData] = useState<any>();

    //主配料窗口
    const [menuWarehouseIngredientVisible, setMenuWarehouseIngredientVisible] = useState(false);

    //主配料数据
    const [ingredientData, setIngredientData] = useState<any>();

    //转移菜式
    // const [warehouseToMenuVisible, setWarehouseToMenuVisible] = useState(false);

    //选择转移菜式
    // const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<any>();

    //规格数据
    const [branchStoreMenuWarehouseSpecData, setBranchStoreMenuWarehouseSpecData] = useState<any>();

    //规格窗口
    const [branchStoreMenuWarehouseSpecVisible, setBranchStoreMenuWarehouseSpecVisible] = useState(false);

    //复制菜式窗口
    const [copyMenuWarehouseVisible, setCopyMenuWarehouseVisible] = useState(false);

    //复制菜式数据
    const [copyMenuWarehouseData, setCopyMenuWarehouseData] = useState<any>();

    /** 菜品类型数据 */
    const [foodTypeData, setFoodTypeData] = useState<any>();

    const [foodTypeIdData, setFoodTypeIdData] = useState<any>();

    /** 分类数据 */
    const [shopTypeData, setShopTypeData] = useState<any>();
    const [shopTypeIdData, setShopTypeIdData] = useState<any>();

    const [printOrderTypeData, setPrintOrderTypeData] = useState<any>([]);

    /** 部门数据 */
    const [deptData, setDeptData] = useState<any>();

    const [deptIdData, setDeptIdData] = useState<any>();

    const [deptId, setDeptId] = useState<any>();
    const [shopTypeId, setShopTypeId] = useState<any>();

    const [loadingData, setLoadingData] = useState<any>(false);

    // 菜谱头数据
    const [menuHeadData, setMenuHeadData] = useState<any>();

    /** 预订菜单类别数据 */
    const [reserveMenuCategoryData, setReserveMenuCategoryData] = useState<any>();

    /**选中的所有数据 */
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    //批量操作窗口
    const [showBatchOperationVisible, setShowBatchOperationVisible] = useState(false);

    //当前的批量操作方式
    const [currentBatchOperation, setCurrentBatchOperation] = useState<any>();

    const batchOperations = [
        {
            key: 'synchronize',
            label: selectedRowKeys.length > 0 ? '同步到...' : (<Tooltip title="请先选择菜品" key="leftButton">
                同步到...
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'shopType',
            label: selectedRowKeys.length > 0 ? '改分类' : (<Tooltip title="请先选择菜品" key="leftButton">
                改分类
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'dept',
            label: selectedRowKeys.length > 0 ? '改出单部门' : (<Tooltip title="请先选择菜品" key="leftButton">
                改出单部门
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'foodType',
            label: selectedRowKeys.length > 0 ? '改菜式类型' : (<Tooltip title="请先选择菜品" key="leftButton">
                改菜式类型
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'reserveMenuCategory',
            label: selectedRowKeys.length > 0 ? '改菜单类别' : (<Tooltip title="请先选择菜品" key="leftButton">
                改菜单类别
            </Tooltip>)
            // disabled: true,
        },
    ];

    /** api服务id */
    const apiId = 'branchStoreMenuWarehouse';

    // /** 后端数据wmService */
    // let wmService: any = systemConfig.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // wmService = ref.current.wmService;
        }

        //同步获取数据 async - await
        const fetchData = async () => {

            fetchApi.GET(wmService, {
                apiId: 'generalData',
                apiVariable: 'printOrderType',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setPrintOrderTypeData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'generalData',
                apiVariable: 'foodType',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setFoodTypeData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'branchStore',
                apiExtend: 'showSingle',
                apiVariable: contextData?.currentBranchStoreId
            }).then(res => {
                if (res.success) {
                    setIsSearchSpec(res.data.branchStoreConfiguration ? res.data.branchStoreConfiguration.isSearchSpec : false);
                    setBranchStoreConfiguration(res.data.branchStoreConfiguration);
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'dept',
                apiExtend: 'showBranchDeptList',
                apiData: {
                    // branchStoreId: localStorage.getItem("currentBranchStoreId"),
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    setDeptData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "menuHead",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    },
                }
            }).then(res => {
                if (res.success) {
                    setMenuHeadData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: "reserveMenuCategory",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId
                }
            }).then(res => {
                if (res.success) {
                    setReserveMenuCategoryData(res.data)
                }
            })

            fetchApi.GET(wmService, {
                apiId: "shopType",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    setShopTypeData(res.data);
                }
            });
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    // const handleTest = (key: any) => {
    //     console.log(key);

    //     fetchApi.GET(wmService, {
    //         apiId: 'branchStoreMenuWarehouse',
    //         apiExtend: key
    //     }).then(res => {
    //         if (res.success) {
    //             console.log(res.data);
    //         }
    //     });
    // }

    //记录选中的菜式Id
    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    //处理批量操作
    const handleBatchOperation = (e: any) => {
        // console.log('click', e);
        // console.log("selectedRowKeys");
        // console.log(selectedRowKeys);
        // console.log("---------------------------");
        switch (e.key) {
            //批量同步
            case "synchronize":
                // console.log("这是批量同步");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("synchronize");
                    batchOperationForm.setFieldsValue({ key: "synchronize" });
                }
                break;

            //批量改菜单类别
            case "reserveMenuCategory":
                // console.log("这是批量改菜单类别");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("reserveMenuCategory");
                    batchOperationForm.setFieldsValue({ key: "reserveMenuCategory" });
                }
                break;

            //批量改出单部门
            case "dept":
                // console.log("这是批量出单部门");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("dept");
                    batchOperationForm.setFieldsValue({ key: "dept" });
                }
                break;

            //批量改分类
            case "shopType":
                // console.log("这是批量改分类");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("shopType");
                    batchOperationForm.setFieldsValue({ key: "shopType" });
                }
                break;

            //批量改菜式类型
            case "foodType":
                // console.log("这是批量改菜式类型");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("foodType");
                    batchOperationForm.setFieldsValue({ key: "foodType" });
                }
                break;
        }
    };

    const batchOperationOk = (e: any) => {
        batchOperationForm.validateFields() //数据校验
            .then(async (values: any) => {
                setLoadingData(true);
                fetchApi.PUT(wmService, {
                    apiId,
                    apiExtend: "batchOperation",
                    apiData: {
                        ...values,
                        apiId,
                        branchStoreId: contextData?.currentBranchStoreId,
                        branchStoreMenuWarehouseIds: selectedRowKeys,
                        mountDataOptions: {
                            userMount: {
                                isBranchStore: true
                            }
                        },
                    }

                }).then(async res => {
                    if (res.success) {
                        setLoadingData(false);
                        antMessage('success', '添加成功', 'success');
                        onCloseBatchOperation();
                        setSelectedRowKeys([]);
                        await initData();
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            }).catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    //关闭批量操作窗口
    const onCloseBatchOperation = () => {
        setShowBatchOperationVisible(false);
        batchOperationForm.setFieldsValue({ synchronizeMenuHeadId: null });
        batchOperationForm.setFieldsValue({ reserveMenuCategoryId: null });
        batchOperationForm.setFieldsValue({ foodType: null });
        batchOperationForm.setFieldsValue({ shopTypeId: null });
        batchOperationForm.setFieldsValue({ deptId: null });
    }

    //打开添加图标
    const handleMenuIcon = async (record: any) => {
        // console.log(record);
        sendData.id = record.id;
        sendData.foodName = record.foodName;
        sendData.path = 'BranchStoreMenuWarehouse';
        setMenuIconData(sendData);
        setMenuIconVisible(true);
    };

    //关闭图标页面
    const onCloseMenuIcon = async (status: boolean) => {
        setMenuIconVisible(false);
    }

    //关闭主配料页面
    const onCloseIngredient = async (status: boolean) => {
        setMenuWarehouseIngredientVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开添加主配料
    const handleIngredient = async (record: any) => {
        if (record.menuWarehouseIngredients.length > 0) {
            let branchStoreId: any = contextData?.currentBranchStoreId;
            if (typeof branchStoreId === 'undefined' || branchStoreId === '') {
                antMessage('error', '错误，请选择当前门店');
            }
            else {
                await fetchApi.POST(wmService, {
                    apiId: 'menuWarehouseIngredientDetail',
                    apiExtend: 'updatePrice',
                    apiData: {
                        branchStoreMenuWarehouseId: record.id,
                        branchStoreId,
                        apiId,
                        key: 'BranchStoreMenuWarehouse'
                    }
                }).then(res => {
                    if (res.success) {
                        // console.log("更新价钱 " + res.data);
                    }
                });
            }
        }

        // console.log(record);
        sendData.id = record.id;
        sendData.branchStoreId = record.branchStore.id;
        if (record.menuWarehouseId) {
            sendData.menuWarehouseId = record.menuWarehouseId;
        }
        sendData.foodName = record.foodName;
        sendData.productUnitName = record.productUnit?.productUnitName;
        sendData.foodType = record.foodType;
        sendData.path = 'BranchStoreMenuWarehouse';
        setIngredientData(sendData);
        setMenuWarehouseIngredientVisible(true);
    };

    //打开添加规格
    const handleBranchStoreMenuWarehouseSpec = (record: any) => {
        // console.log(record)
        sendData.id = record.id;
        sendData.foodName = record.foodName;
        sendData.branchStoreId = record.branchStore.id;
        sendData.branchStoreMenuWarehouseId = record.id;
        sendData.menuWarehouseId = record.menuWarehouseId;
        sendData.foodType = record.foodType;
        setBranchStoreMenuWarehouseSpecData(sendData);
        setBranchStoreMenuWarehouseSpecVisible(true);
    };

    // 打开同步/关联
    const handleSynchronize = (record: any, key: any) => {
        // console.log(record);
        sendData.branchStoreMenuWarehouseId = record.id;
        sendData.foodName = record.foodName;
        sendData.foodNameEn = record.foodNameEn;
        sendData.description = record.description;
        sendData.introduction = record.introduction;
        sendData.source = record.source;
        sendData.branchStoreMenuWarehouseSpecRow = record.branchStoreMenuWarehouseSpecs;
        sendData.branchStoreId = record.branchStoreId;
        sendData.brandId = record.branchStore.brandId;
        sendData.menuWarehouseId = record.menuWarehouseId;
        sendData.key = key;
        sendData.path = 'BranchStoreMenuWarehouse';
        setSynchronizeData(sendData);
        setSynchronizeVisible(true);
    };

    const handleOk = (e: any) => {
        setLoadingData(true);
        form.validateFields() //数据校验
            .then(async (values: any) => {
                // console.log(values);
                fetchApi.POST(wmService, {
                    apiId: 'branchStoreMenuWarehouse',
                    apiExtend: 'noPrintOrder',
                    apiData: {
                        ...values,
                        mountDataOptions: {
                            userMount: {
                                isDept: true
                            }
                        }
                    }
                }).then(res => {
                    if (res.success) {
                        antMessage('success', '添加成功', 'success');
                        setLoadingData(false);
                        onCloseNoPrintOrder();
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                    setLoadingData(false);
                })
            })
            .catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
                setLoadingData(false);
            });
    };

    // 打开分类设置不打印窗口
    const handleNoPrintOrder = () => {
        setNoPrintOrderVisible(true);
        form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

        // fetchApi.GET(wmService, {
        //     apiId: "shopType",
        //     apiExtend: 'showList',
        //     apiData: {
        //         // branchStoreId: localStorage.getItem("currentBranchStoreId"),
        //         branchStoreId: contextData?.currentBranchStoreId,
        //         mountDataOptions: {
        //             userMount: {
        //                 isDept: true
        //             }
        //         }
        //     }
        // }).then(res => {
        //     if (res.success) {
        //         setShopTypeData(res.data);
        //     }
        // });
    };

    //关闭分类设置不打印窗口
    const onCloseNoPrintOrder = () => {
        form.setFieldsValue({ shopTypesId: [] });
        form.setFieldsValue({ noPrintOrder: [] });
        form.setFieldsValue({ wxNoPrintOrder: [] });
        form.setFieldsValue({ isDelete: false });
        setNoPrintOrderVisible(false);
    }

    //关闭同步页面
    const onCloseSynchronize = async (status: boolean) => {
        setSynchronizeVisible(false);
        if (status) {
            await initData();
        }
    }

    //关闭门店菜式规格页面
    const onCloseBranchStoreMenuWarehouseSpec = async (status: boolean) => {
        setBranchStoreMenuWarehouseSpecVisible(false);
        if (status) {
            await initData();
        }
    }

    //关闭穿梭框页面
    // const onCloseWarehouseToMenu = async (status: boolean) => {
    //     setWarehouseToMenuVisible(false);
    //     if (status) {
    //         await initData();
    //     }
    // }

    /**
     * 复制菜式
     */
    const handleCopy = () => {
        sendData.path = 'BranchStoreMenuWarehouse';
        setCopyMenuWarehouseData(sendData);
        setCopyMenuWarehouseVisible(true);
    };

    /**
     * 更新所有菜式的英文
     */
    // const updateAllEn = (record: any) => {
    //     // console.log(record);
    //     if (record.menuWarehouseId) {
    //         fetchApi.POST(wmService, {
    //             apiId: "branchStoreMenuWarehouse",
    //             apiExtend: 'updateMenuWarehouseEn',
    //             apiData: {
    //                 branchStoreMenuWarehouseId: record.id
    //             }
    //         }).then(res => {
    //             if (res.success) {
    //                 // console.log(res.data);
    //                 console.log("门店菜式：【 " + record.foodName + "】  英文更新为【 " + res.data.foodNameEn + " 】");
    //                 if (res.data.menus.length > 0) {
    //                     for (var menus = 0; menus < res.data.menus.length; menus++) {
    //                         console.log("---------【" + res.data.menus[menus].menuHead.menuHeadName + "】菜式：【 " + res.data.menus[menus].foodName + "】  英文更新为【 " + res.data.foodNameEn + " 】");
    //                     }
    //                 }
    //                 console.log("")
    //                 console.log("")
    //             }
    //         });
    //     }
    // };

    // 打开从菜式仓选择到门店
    // const handleSelectMenuWarehouse = () => {
    //     sendData.key = 'menuWarehouseToBranchStore';
    //     setBranchStoreMenuWarehouseData(sendData);
    //     setWarehouseToMenuVisible(true);
    // };

    const handleDelete = (record: any) => {
        fetchApi.DELETE(wmService, {
            apiId,
            apiExtend: "remove",
            apiVariable: record.id,
            apiData: {
                // branchStoreId: localStorage.getItem("currentBranchStoreId")
                branchStoreId: contextData?.currentBranchStoreId
            }
        }).then(async res => {
            if (res.success) {
                antMessage('success', res.data.message, 'success');
                await initData();
                // if (res.data.state) {
                //     closeModal(true);
                // }
            }
        }).catch(err => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误，无法保存",
                description: err.message + ' | status：' + err.errors.status,
            });
        })
    };

    const initData = async () => {
        // const menuHeadId = data.menuHeadId;
        const currentData: initDataType = {
            apiId,
            // sendPageData: { menuHeadId: menuHeadId }
        }
        ref.current.initData(currentData);
    }

    const setInventory = () => {
        fetchApi.POST(wmService, {
            apiId: "branchStoreMenuWarehouse",
            apiExtend: "setInventory",
            apiData: {
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                },
            }
        }).then(async (res) => {
            await initData()

        }).catch((err) => {

        })
    }

    //查看不同分类/不同类型/不同部门的菜式
    const selectChange = (e: any, key: any, setData: any, setOtherData?: any) => {
        setData(e);
        if (setOtherData) {
            setOtherData(e);
        }
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                deptId: key === 'dept' ? e : deptIdData,
                shopTypeId: key === 'shopType' ? e : shopTypeIdData,
                foodTypeId: key === 'foodType' ? e : foodTypeIdData,
                branchStoreId: contextData?.currentBranchStoreId,
                isSearchSpec
            }
        }
        ref.current.initData(currentData);
    }

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        fetchApi.GET(wmService, {
            apiId: 'dept',
            apiExtend: 'showBranchDeptList',
            apiData: {
                // branchStoreId: localStorage.getItem("currentBranchStoreId"),
                branchStoreId: contextData?.currentBranchStoreId,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success) {
                setDeptData(res.data);
            }
        });

        setDeptId(undefined);
        setShopTypeId(undefined);
        setDeptIdData(undefined);
        setShopTypeIdData(undefined);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                deptId: undefined,
                shopTypeId: undefined,
                foodTypeId: foodTypeIdData,
                branchStoreId, isSearchSpec
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    /**
     * 取消关联仓库
     */
    const cancelConnect = (record: any) => {
        fetchApi.GET(wmService, {
            apiId: "branchStoreMenuWarehouse",
            apiExtend: 'cancelConnect',
            apiVariable: record.id,
        }).then(async res => {
            if (res.success) {
                await initData();
            }
        });
    };

    const handleSwitch = (e: any) => {
        fetchApi.PUT(wmService, {
            apiId: "branchStoreConfiguration",
            apiVariable: branchStoreConfiguration.id,
            apiExtend: 'updateOne',
            apiData: {
                columnName: "isSearchSpec",
                value: e,
            }
        }).then(async res => {
            if (res.success) {
                await initData();
            }
        });

        setIsSearchSpec(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                deptId: deptIdData,
                shopTypeId: shopTypeIdData,
                foodTypeId: foodTypeIdData,
                branchStoreId: contextData?.currentBranchStoreId,
                isSearchSpec: e
            }
        }
        ref.current.initData(currentData);
    }

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                // updateAllEn(record);
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                if (sessionStorage.getItem('isAdmin') === 'true') {
                    if (record.isReadyDelete) {
                        return (
                            <Tooltip placement="topLeft" title={record.menuWarehouse ? "【" + record.menuWarehouse.brandId + "】" + record.menuWarehouse.foodName : '暂时未关联仓库菜式'} color='green'>
                                <div><span style={{ color: 'red' }}>【待删除】</span>{text}</div>
                            </Tooltip>
                        )
                    }
                    else {
                        return (
                            <Tooltip placement="topLeft" title={record.menuWarehouse ? "【" + record.menuWarehouse.brandId + "】" + record.menuWarehouse.foodName : '暂时未关联仓库菜式'} color='green'>
                                <div>{text}</div>
                            </Tooltip>
                        )
                    }
                }
                else {
                    if (record.isReadyDelete) {
                        return (
                            <div><span style={{ color: 'red' }}>【待删除】</span>{text}</div>
                        )
                    }
                    else {
                        return (
                            <div>{text}</div>
                        )
                    }
                }
            }
        },
        {
            title: '分类',
            dataIndex: 'shopTypeName',
            render: (text: any, record: any) => {
                if (record.shopType) {
                    return (
                        <div>{record.shopType.shopTypeName}</div>
                    )
                }
            }
        },
        {
            title: '简码',
            dataIndex: 'selfId',
            sorter: true,
        },
        {
            title: '类型',
            dataIndex: 'foodTypeName',
        },
        {
            title: '出单部门',
            dataIndex: 'deptName',
            render: (text: any, record: any) => {
                if (record.dept) {
                    return (
                        <Tooltip placement="topLeft" title={record.isPrint ? '设置为【打印】 ' : '设置为【不打印】 '} color='red'>
                            <div>{record.dept.deptName + (record.specialDept ? " ----- " + record.specialDept.deptName + " (特殊)" : "")}</div>
                        </Tooltip>
                    )
                }
                else {
                    return (
                        <p>
                            <div style={{ color: 'red', fontSize: '15px' }}>设置出单部门后才能进行后续操作</div>
                        </p>
                    )
                }
            }
        },
        {
            title: '单位',
            dataIndex: 'productUnitName',
            render: (text: any, record: any) => {
                if (record.productUnit) {
                    return (
                        <div>{record.productUnit.productUnitName}</div>
                    )
                }
            }
        },
        {
            title: '价钱',
            dataIndex: 'price',
            render: (text: any, record: any) => {
                if (record.branchStoreMenuWarehouseSpecs.length > 0) {
                    return (
                        <div style={{ fontSize: 20, color: localStorage.getItem("themeMode") === '1' ? 'yellow' : 'red' }}>
                            {record.branchStoreMenuWarehouseSpecs.length === 1 ? record.branchStoreMenuWarehouseSpecs[0].price : record.branchStoreMenuWarehouseSpecs[0].price + " - " + record.branchStoreMenuWarehouseSpecs[record.branchStoreMenuWarehouseSpecs.length - 1].price}
                        </div>
                    )
                }
            }
        },
        {
            title: '规格',
            dataIndex: '',
            key: 'branchStoreMenuWarehouseSpec',
            render: (text: any, record: any) => {
                if (record.dept) {
                    if (record.branchStoreMenuWarehouseSpecs.length > 0) {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="primary" onClick={() => handleBranchStoreMenuWarehouseSpec(record)}>规格</Button>
                            </Space>
                        )
                    }
                    else {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="primary" danger onClick={() => handleBranchStoreMenuWarehouseSpec(record)}>规格</Button>
                            </Space>
                        )
                    }
                }
            }
        },
        {
            title: '主配料',
            dataIndex: 'menuWarehouseIngredientCount',
            key: 'menuWarehouseIngredientCount',
            sorter: (a: { menuWarehouseIngredientCount: number; }, b: { menuWarehouseIngredientCount: number; }) => a.menuWarehouseIngredientCount - b.menuWarehouseIngredientCount,
            render: (text: any, record: any) => {
                if (record.dept) {
                    switch (text) {
                        //没有主配料数据
                        case 0:
                            return (
                                <Space size="small">
                                    <Button size={"small"} danger type="primary" onClick={() => handleIngredient(record)}>主配料</Button>
                                </Space>
                            )
                        //主配料数据和规格的数据总数不同
                        case 1:
                            return (
                                <Space size="small">
                                    <Button size={"small"} color="green" variant="solid" onClick={() => handleIngredient(record)}>主配料</Button>
                                </Space>
                            )
                        //主配料已经全部填写完毕
                        case 2:
                            return (
                                <Space size="small">
                                    <Button size={"small"} type="primary" onClick={() => handleIngredient(record)}>主配料</Button>
                                </Space>
                            )
                    }
                }
            }
        },
        {
            title: '图标',
            dataIndex: '',
            key: 'menuIcon',
            render: (text: any, record: any) => {
                if (record.dept) {
                    if (record.branchStoreMenuWarehouseSpecs.length > 0) {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="primary" onClick={() => handleMenuIcon(record)}>图标</Button>
                            </Space>
                        )
                    }
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text: any, record: any) => {
                // console.log(record);
                if (record.dept) {
                    if (record.menuWarehouseId) {
                        if (record.branchStoreMenuWarehouseSpecs.length > 0) {
                            if (sessionStorage.getItem('isAdmin') === 'true') {
                                return (
                                    <Space size="small">
                                        <Button size={"small"} type="primary" onClick={() => handleSynchronize(record, 'ToMenuWarehouse')}>同步到...</Button>
                                        <span>&nbsp;&nbsp;</span>
                                        <Button size={"small"} type="primary" onClick={() => cancelConnect(record)}>取消关联仓库</Button>
                                    </Space>
                                )
                            }
                            else {
                                return (
                                    <Space size="small">
                                        <Button size={"small"} type="primary" onClick={() => handleSynchronize(record, 'ToMenuWarehouse')}>同步到...</Button>
                                    </Space>
                                )
                            }
                        }
                    }
                    else {
                        if (record.branchStoreMenuWarehouseSpecs.length > 0) {
                            if (sessionStorage.getItem('isAdmin') === 'true') {
                                return (
                                    <Space size="small">
                                        <Button size={"small"} type="primary" onClick={() => handleSynchronize(record, 'ToMenuWarehouse')}>同步到...</Button>
                                        <span>&nbsp;&nbsp;</span>
                                        <Button size={"small"} type="primary" onClick={() => handleSynchronize(record, 'FromMenuWarehouse')}>关联</Button>
                                    </Space>
                                )
                            }
                            else {
                                return (
                                    <Space size="small">
                                        <Button size={"small"} type="primary" onClick={() => handleSynchronize(record, 'ToMenuWarehouse')}>同步到...</Button>
                                    </Space>
                                )
                            }

                        }
                    }
                }
            }
        },
        sessionStorage.getItem('isAdmin') === 'true' ?
            {
                title: '菜单类别',
                dataIndex: 'reserveMenuCategoryId',
                render: (text: any, record: any) => {
                    if (record.reserveMenuCategoryId) {
                        return (
                            <Tooltip placement="topLeft" title={'当前菜单类别为： ' + record.reserveMenuCategory.reserveMenuCategoryName} color='red'>
                                <Switch checkedChildren="是" unCheckedChildren="否"
                                    checked={text} key={record.id} disabled
                                />
                            </Tooltip>
                        )
                    }
                    else {
                        return (
                            <Switch checkedChildren="是" unCheckedChildren="否"
                                checked={text} key={record.id} disabled
                            />
                        )
                    }
                }
            } : {},
        {
            title: "待删除",
            dataIndex: "isReadyDelete",
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                    onChange={(e) => ref.current.handleChangeOne(record.id, 'isReadyDelete', e, apiId)}
                />
            )
        },
    ];

    // /** 子表头内容 */
    // const expandableColumnsHead: Array<any> = [
    //     {
    //         title: "规格",
    //         dataIndex: "branchStoreMenuWarehouseSpecName",
    //         render: (text: any, record: any) => {
    //             // console.log("record", record);
    //             return <>
    //                 {record.branchStoreMenuWarehouseSpecName}
    //             </>
    //         }
    //     },
    //     {
    //         title: "基础价",
    //         dataIndex: "price",
    //         render: (text: any, record: any) => {
    //             // console.log("record", record);
    //             return <>
    //                 {record.price}
    //             </>
    //         }
    //     }
    // ]

    /** 子表头 */
    // const expandableColumns = expandableColumnsHead;

    const columns = columnsheadId
        .concat(columnsHead as []);

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        branchStoreMenuWarehouseId: '',
        menuWarehouseId: '',
        branchStoreMenuWarehouseSpecRow: '',
        foodName: '',
        foodNameEn: '',
        productUnitName: '',
        description: '',
        introduction: '',
        source: '',
        branchStoreId: '',
        brandId: '',
        foodType: '',
        key: '',
        path: ''
    }

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '门店菜式',
        apiId,
        columns,
        showStates: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
        showEdit: true,
        pagination: true,
        isAutomaticRefresh: true,
        showDelete: true,
        showAdd: true,
        EditComponent: BranchStoreMenuWarehouseEdit,
        sendPageData: {
            branchStoreId: contextData?.currentBranchStoreId
        },
        coverHandleDelete: handleDelete,
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        },

        //子表格
        // isExpandable: true,
        // expandableColumns,
        // expandableDataName: 'branchStoreMenuWarehouseSpecs',

        //多选
        rowSelection: {
            selectedRowKeys,
            onChange: onSelectChange,
            type: "checkbox",
        },
    };

    const returnAntd = () => {
        return (
            <Form
                form={form}
                name="Edit"
            >
                <Row gutter={[8, 0]}>
                    <Col span={0}>
                        <Form.Item
                            label="门店Id"
                            name="branchStoreId"
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="选择分类"
                            name="shopTypesId"
                            rules={[{ required: true, message: '请选择分类!' }]}>
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="选择分类"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(shopTypeData, 'shopTypeName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="不打印订单(叫卖)"
                            name="noPrintOrder"
                            tooltip="【叫卖模式】指定该菜不打印在某些单里，目前暂时只支持堂口单，客看单，厨总单">
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="订单类型"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(printOrderTypeData, 'name')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="不打印订单(微信)"
                            name="wxNoPrintOrder"
                            tooltip="【微信下单模式】指定该菜不打印在某些单里，目前暂时只支持堂口单，客看单，厨总单">
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="订单类型"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(printOrderTypeData, 'name')}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="增加/删除不打印订单"
                            name="isDelete"
                            valuePropName="checked"
                            initialValue={false}>
                            <Switch checked={false}
                                checkedChildren="删除"
                                unCheckedChildren="增加" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }

    return (
        <>
            <div>
                <Space>
                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        onChange={(e) => selectChange(e, "foodType", setFoodTypeIdData)}
                        onClear={() => selectChange(undefined, "foodType", setFoodTypeIdData)}
                        placeholder="菜品类型"
                        optionFilterProp="children"
                        filterOption={(input, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getList.generalEx(foodTypeData, {
                            includeNull: false
                        })}
                    </Select>

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        onChange={(e) => selectChange(e, "dept", setDeptIdData, setDeptId)}
                        onClear={() => selectChange(undefined, "dept", setDeptIdData, setDeptId)}
                        value={deptId}
                        placeholder="部门"
                        optionFilterProp="children"
                        filterOption={(input, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getList.general(deptData, "deptName")}
                    </Select>

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        value={shopTypeId}
                        onChange={(e) => selectChange(e, "shopType", setShopTypeIdData, setShopTypeId)}
                        onClear={() => selectChange(undefined, "shopType", setShopTypeIdData, setShopTypeId)}
                        placeholder="分类"
                        optionFilterProp="children"
                        filterOption={(input, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getList.general(shopTypeData, "shopTypeName")}
                    </Select>

                    <Dropdown.Button type="primary" menu={{ items: batchOperations, onClick: handleBatchOperation }} trigger={["hover"]}>批量</Dropdown.Button>

                    {sessionStorage.getItem('isAdmin') === 'true'
                        ? (<Button type="primary" onClick={handleCopy}>将门店所有菜式复制到其他门店</Button>)
                        : null}
                    <Popconfirm title="确定要一键恢复(设置)库存吗?" onConfirm={setInventory}>
                        <Button type='primary' >一键恢复(设置)库存</Button>
                    </Popconfirm>

                    <Popconfirm title="确定当前分类商品沽清吗?" onConfirm={setInventory}>
                        <Button type='primary' >当前分类商品沽清</Button>
                    </Popconfirm>

                    <Button type="primary" onClick={handleNoPrintOrder}>分类设置单据不打印</Button>
                </Space>
            </div>
            <Modal
                title={"批量操作"}
                open={showBatchOperationVisible}
                onOk={batchOperationOk}
                onCancel={onCloseBatchOperation}
                closable={false}
                style={{ fontSize: '20px' }}
                okButtonProps={{ disabled: loadingData }}
                confirmLoading={loadingData}
                width={500}
            >
                <Form
                    form={batchOperationForm}
                    name="Edit"
                    style={{ height: 450 }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={0}>
                            <Form.Item
                                label="key"
                                name="key">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item>
                                <Alert
                                    message={"共选择了 " + selectedRowKeys.length + " 个菜式 , 进行以下批量操作"}
                                    // description="进行以下批量操作"
                                    type="success"
                                    style={{ fontSize: 30 }}
                                />
                            </Form.Item>
                        </Col>

                        {currentBatchOperation === 'synchronize' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择菜谱类型"
                                        name="synchronizeMenuHeadId"
                                        rules={[{ required: currentBatchOperation === "synchronize" ? true : false, message: '请选择菜谱类型!' }]}>
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            placeholder="选择菜谱类型"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(menuHeadData, 'menuHeadName')}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                        {currentBatchOperation === 'reserveMenuCategory' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择预订菜单类别"
                                        name="reserveMenuCategoryId"
                                        rules={[{ required: currentBatchOperation === "reserveMenuCategory" ? true : false, message: '请选择预订菜单类别!' }]}>
                                        <Select
                                            showSearch
                                            placeholder="选择预订菜单类别"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(reserveMenuCategoryData, 'reserveMenuCategoryName')}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                        {currentBatchOperation === 'shopType' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择分类"
                                        name="shopTypeId"
                                        rules={[{ required: currentBatchOperation === "shopType" ? true : false, message: '请选择分类!' }]}>
                                        <Select
                                            showSearch
                                            placeholder="选择分类"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(shopTypeData, 'shopTypeName')}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                        {currentBatchOperation === 'dept' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择出单部门"
                                        name="deptId"
                                        rules={[{ required: currentBatchOperation === "dept" ? true : false, message: '请选择出单部门!' }]}>
                                        <Select
                                            showSearch
                                            placeholder="选择出单部门"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(deptData, 'deptName')}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                        {currentBatchOperation === 'foodType' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择菜式类型"
                                        name="foodType"
                                        rules={[{ required: currentBatchOperation === "foodType" ? true : false, message: '请选择菜式类型!' }]}>
                                        <Select
                                            showSearch
                                            placeholder="选择菜式类型"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.generalEx(foodTypeData, {
                                                includeNull: false
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                    </Row>
                </Form>
            </Modal>
            <br></br>
            <Modal
                title="分类批量设置单据不打印"
                open={noPrintOrderVisible}
                okText='确定'
                onOk={handleOk}
                onCancel={onCloseNoPrintOrder}
                cancelButtonProps={{ disabled: loadingData }}
                okButtonProps={{ disabled: loadingData }}
                maskClosable={false}
                style={{ fontSize: '20px' }}
                width={1000}
            >
                {loadingData ? (
                    <Spin size="large" tip="Loading...">
                        {returnAntd()}
                    </Spin>
                ) : returnAntd()}
            </Modal>
            <br></br>
            <Switch
                checkedChildren="搜规格/特殊规格"
                unCheckedChildren="不搜规格/特殊规格"
                onChange={handleSwitch}
                checked={isSearchSpec}
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>

            {synchronizeVisible
                ? (<Synchronize
                    closeModal={onCloseSynchronize} data={synchronizeData} />)
                : null}

            {branchStoreMenuWarehouseSpecVisible
                ? (<BranchStoreMenuWarehouseSpec
                    closeModal={onCloseBranchStoreMenuWarehouseSpec} data={branchStoreMenuWarehouseSpecData} />)
                : null}

            {/* {warehouseToMenuVisible
                ? (<WarehouseToMenu
                    closeModal={onCloseWarehouseToMenu} data={branchStoreMenuWarehouseData} />)
                : null} */}

            {copyMenuWarehouseVisible
                ? (<CopyMenuWarehouse
                    closeModal={setCopyMenuWarehouseVisible} data={copyMenuWarehouseData} branchStoreId={contextData?.currentBranchStoreId} />)
                : null}

            {menuWarehouseIngredientVisible
                ? (<MenuWarehouseIngredient
                    closeModal={onCloseIngredient} data={ingredientData} />)
                : null}

            {menuIconVisible
                ? (<MenuIcon
                    closeModal={onCloseMenuIcon} data={menuIconData} />)
                : null}
        </>
    )
}